//import { dateUtil } from "@repo/lib-common";
const cdnRootUrl = "https://cdn.adpartners.io/adp-client/dist";
export function prepareOffCanvas(str: string, onCloseCallback?: VoidFunction) {
    const offCanvas = document.createElement('div');
    offCanvas.className = '_mdco-offcanvas _mdco-offcanvas-end';

    // Offcanvas header
    const header = document.createElement('div');
    header.classList.add('_mdco-offcanvas-header');
    const closeButton = document.createElement('button');
    closeButton.type = 'button';
    closeButton.classList.add('_mdco-offcanvas-close');
    closeButton.setAttribute('data-bs-dismiss', 'offcanvas');
    closeButton.setAttribute('aria-label', 'Close');

    closeButton.addEventListener('click', () => {
        closeOffCanvas(offCanvas);
        if (onCloseCallback) {
            onCloseCallback();
        }
    });


    header.appendChild(closeButton);
    offCanvas.appendChild(header);

    // Offcanvas body
    const body = document.createElement('div');
    body.classList.add('_mdco-offcanvas-body');

    // Body content
    const contentWrapper = document.createElement('div');
    contentWrapper.className = '_mdco-df _mdco-aic _mdco-mb-4';
    const imgSpan = document.createElement('span');
    imgSpan.classList.add('_mco-me-1');
    const img = document.createElement('img');
    img.src = cdnRootUrl + '/img/gift.svg';
    img.alt = '';
    imgSpan.appendChild(img);
    const heading = document.createElement('h3');
    heading.className = 'fs-1 fw-normal text-color _mdco-m-0';
    heading.textContent = 'PAYLAŞ KAZAN';
    contentWrapper.appendChild(imgSpan);
    contentWrapper.appendChild(heading);

    const linkReady = document.createElement('div');
    linkReady.classList.add('fs-2');
    linkReady.textContent = 'Link Paylaşıma Hazır';

    const description = document.createElement('p');
    description.classList.add('fs-6');
    description.textContent = 'Bu ürünün linkini istediğiniz kişilerle Whatsapp veya sosyal medya hesaplarınızdan paylaşın, linkinizden satın alım yapıldıkça kazanın!';

    const resultContent = document.createElement('div');
    resultContent.id = '_mdco-result-content';

    // Copy link button
    const copyLinkDiv = document.createElement('div');
    copyLinkDiv.className = '_mdco-df _mdco-aic _mdco-jcb';
    const copyLinkButton = document.createElement('button');
    copyLinkButton.classList.add('_mdco-copy-link-button');
    copyLinkButton.id = '_mdco-copy-link-button';
    copyLinkButton.addEventListener('click', () => {
        copyTextFromSpan();
    });
    const copyLinkImg = document.createElement('img');
    copyLinkImg.src = cdnRootUrl + '/img/copy.svg';
    copyLinkImg.height = 28;
    const copyLinkSpan = document.createElement('span');
    copyLinkSpan.appendChild(copyLinkImg);
    copyLinkButton.appendChild(copyLinkSpan);
    const span = Object.assign(document.createElement('span'), { textContent: 'Kopyala' });
    copyLinkButton.appendChild(span);
    copyLinkDiv.appendChild(copyLinkButton);
    resultContent.appendChild(copyLinkDiv);

    // Footer content
    const footer = document.createElement('div');
    footer.className = '_mdco-text-end';
    //footer.textContent = 'hebele';
    const footerLink = document.createElement('span');
    footerLink.className = '_mdco-page-bottom-link';
    footer.appendChild(footerLink);
    const footerText = document.createElement('span');
    footerText.className = '_mdco-direct-link';
    footerText.textContent = str;
    footerLink.appendChild(footerText);

    body.appendChild(contentWrapper);
    body.appendChild(linkReady);
    body.appendChild(description);
    body.appendChild(resultContent);
    copyLinkDiv.appendChild(footer);

    const share = document.createElement('div');
    share.className = '_mdco-share';
    const shareButtons = `<div class="_mdco-share-title">Bu ürünü sevdiklerinizle paylaşabilirsiniz.</div>
                            <div class="_mdco-df _mdco-share-items">
                                <div>
                                    <button class="_mdco-share-button" id="shareOnLinkedin">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 30 29" fill="none">
                                            <path d="M4 0C2.9 0 1.92 0.33 1.19 0.94C0.46 1.55 0.01 2.47 0.01 3.46C0.01 5.32 1.63 6.78 3.69 6.92C3.79 6.95 3.89 6.97 3.99 6.97C6.26 6.97 7.98 5.38 7.98 3.45C7.98 3.43 7.98 3.41 7.98 3.4C7.88 1.5 6.18 0 3.99 0H4ZM4 1.98C5.39 1.98 5.94 2.6 6 3.48C5.99 4.34 5.46 5 4 5C2.54 5 1.99 4.29 1.99 3.46C1.99 3.04 2.14 2.73 2.46 2.46C2.78 2.19 3.29 1.98 4 1.98ZM1 7.99C0.45 7.99 0 8.44 0 8.99V27.99C0 28.54 0.45 28.99 1 28.99H7C7.55 28.99 8 28.54 8 27.99V8.99C8 8.44 7.55 7.99 7 7.99H1ZM10 7.99C9.45 7.99 9 8.44 9 8.99V27.99C9 28.54 9.45 28.99 10 28.99H16C16.55 28.99 17 28.54 17 27.99V17.99C17 17.16 17.23 16.34 17.62 15.79C18.01 15.24 18.52 14.93 19.48 14.94C20.47 14.96 20.99 15.29 21.38 15.82C21.77 16.35 22 17.14 22 17.98V27.98C22 28.53 22.45 28.98 23 28.98H29C29.55 28.98 30 28.53 30 27.98V17.24C30 14.28 29.12 11.93 27.62 10.35C26.12 8.77 24.03 7.98 21.81 7.98C19.59 7.98 18.11 8.68 17 9.4V8.98C17 8.43 16.55 7.98 16 7.98H10V7.99ZM2 9.99H6V26.99H2V9.99ZM11 9.99H15V11.55C15 12.1 15.45 12.55 16 12.55C16.31 12.55 16.61 12.4 16.8 12.15C16.8 12.15 18.37 9.99 21.81 9.99C23.56 9.99 25.07 10.57 26.17 11.73C27.27 12.89 28 14.68 28 17.25V26.99H24V17.99C24 16.82 23.72 15.62 22.99 14.64C22.26 13.66 21.03 12.98 19.52 12.95C18 12.92 16.75 13.62 16.02 14.61C15.29 15.6 15 16.82 15 17.99V26.99H11V9.99Z" fill="black"/>
                                        </svg>
                                    </button>
                                </div>
                                <div>
                                    <button class="_mdco-share-button" id="shareOnX" data-url="${str}" data-title="Paylaş Kazan" data-company="MadameCocoTR">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-twitter-x" viewBox="0 0 16 16">
                                            <path d="M12.6.75h2.454l-5.36 6.142L16 15.25h-4.937l-3.867-5.07-4.425 5.07H.316l5.733-6.57L0 .75h5.063l3.495 4.633L12.601.75Zm-.86 13.028h1.36L4.323 2.145H2.865z"/>
                                        </svg>
                                    </button>
                                </div>
                                <div>
                                    <button class="_mdco-share-button" id="shareOnFacebook">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="25" height="45" viewBox="0 0 25 45" fill="none">
                                            <path d="M24.02 15C23.9 14.86 23.74 14.79 23.56 14.79H16.51V12.79C16.51 10.44 17.13 9.24 18.36 9.24H23.46C23.79 9.24 24.06 8.97 24.06 8.64V1.87L24.01 0.99C24.01 0.71 23.78 0.47 23.49 0.43L22.62 0.31C21.86 0.21 20.26 0 17.33 0C10.15 0 6.19 4.26 6.19 12.01V14.79H0.6C0.27 14.79 0 15.06 0 15.39V23.96C0 24.29 0.27 24.56 0.6 24.56H6.19V44.07C6.19 44.4 6.46 44.67 6.79 44.67H7.79C8.45 44.67 10.05 44.68 11.58 44.69C13.01 44.71 14.38 44.71 14.91 44.71H15.91C16.24 44.71 16.51 44.45 16.51 44.12V24.56H22.24C22.53 24.56 22.79 24.34 22.83 24.05L24.16 15.48C24.18 15.31 24.13 15.13 24.02 15ZM13.31 21.96V41.51L9.39 41.48V21.96C9.39 21.63 9.12 21.36 8.79 21.36H3.2V17.99H8.79C9.12 17.99 9.39 17.72 9.39 17.39V12.01C9.39 6 11.91 3.2 17.33 3.2C18.66 3.2 19.82 3.24 20.86 3.33V6.04H18.36C15.24 6.04 13.31 8.63 13.31 12.79V17.39C13.31 17.72 13.58 17.99 13.91 17.99H20.53L20.01 21.36H13.91C13.58 21.36 13.31 21.63 13.31 21.96Z" fill="black"/>
                                        </svg>
                                    </button>
                                </div>
                                <div>
                                    <a href="whatsapp://send?text=${str}" aria-label="Whatsapp'da paylaş" data-action="share/whatsapp/share" class="_mdco-share-button" id="shareOnWhatsapp">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-whatsapp" viewBox="0 0 16 16">
                                            <path d="M13.601 2.326A7.85 7.85 0 0 0 7.994 0C3.627 0 .068 3.558.064 7.926c0 1.399.366 2.76 1.057 3.965L0 16l4.204-1.102a7.9 7.9 0 0 0 3.79.965h.004c4.368 0 7.926-3.558 7.93-7.93A7.9 7.9 0 0 0 13.6 2.326zM7.994 14.521a6.6 6.6 0 0 1-3.356-.92l-.24-.144-2.494.654.666-2.433-.156-.251a6.56 6.56 0 0 1-1.007-3.505c0-3.626 2.957-6.584 6.591-6.584a6.56 6.56 0 0 1 4.66 1.931 6.56 6.56 0 0 1 1.928 4.66c-.004 3.639-2.961 6.592-6.592 6.592m3.615-4.934c-.197-.099-1.17-.578-1.353-.646-.182-.065-.315-.099-.445.099-.133.197-.513.646-.627.775-.114.133-.232.148-.43.05-.197-.1-.836-.308-1.592-.985-.59-.525-.985-1.175-1.103-1.372-.114-.198-.011-.304.088-.403.087-.088.197-.232.296-.346.1-.114.133-.198.198-.33.065-.134.034-.248-.015-.347-.05-.099-.445-1.076-.612-1.47-.16-.389-.323-.335-.445-.34-.114-.007-.247-.007-.38-.007a.73.73 0 0 0-.529.247c-.182.198-.691.677-.691 1.654s.71 1.916.81 2.049c.098.133 1.394 2.132 3.383 2.992.47.205.84.326 1.129.418.475.152.904.129 1.246.08.38-.058 1.171-.48 1.338-.943.164-.464.164-.86.114-.943-.049-.084-.182-.133-.38-.232"/>
                                        </svg>
                                    </a>
                                </div>
                                <div>
                                    <a href="mailto:?subject=Paylaş Kazan&body=${str}" aria-label="Paylaş kazan" class="_mdco-share-button" id="shareViaEmail">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" class="bi bi-envelope" viewBox="0 0 16 16">
                                            <path d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-1a1 1 0 0 0-1 1v.217l7 4.2 7-4.2V4a1 1 0 0 0-1-1zm13 2.383-4.708 2.825L15 11.105zm-.034 6.876-5.64-3.471L8 9.583l-1.326-.795-5.64 3.47A1 1 0 0 0 2 13h12a1 1 0 0 0 .966-.741M1 11.105l4.708-2.897L1 5.383z"/>
                                        </svg>
                                    </a>
                                </div>
                            </div>`;
    share.innerHTML = shareButtons;
    body.appendChild(share);

    offCanvas.appendChild(body);

    document.body.appendChild(offCanvas);

    setTimeout(() => {
        offCanvas.setAttribute('aria-modal', 'true');
        offCanvas.classList.add('showing');
        offCanvas.classList.add('show');
        createOffcanvasBackdrop(offCanvas);
        setTimeout(() => {
            offCanvas.classList.remove('showing');
        }, 300);
    }, 10);

    document.addEventListener('click', (e: MouseEvent) => {
        const el = e.target as HTMLButtonElement;
        console.log(el);

        if (el.matches('._mdco-share-button')) {
            if (el.id === 'shareOnFacebook') {
                const dataurl = str;
                return window.open(
                    "https://www.facebook.com/sharer/sharer.php?u=" + encodeURIComponent(dataurl),
                    "facebooksharedialog",
                    "toolbar=0,status=0,width=626,height=436"
                )
            }

            if (el.id === 'shareOnX') {
                const e = el.getAttribute('data-url') as string;
                const o = el.getAttribute('data-company') as string;
                const n = el.getAttribute('data-title') as string;
                return window.open(
                    "https://twitter.com/intent/tweet?hashtags=" + o + "&original_referer=" + encodeURIComponent(e) + "&related=" + o + "&text=" + encodeURIComponent(n) + "&url=" + encodeURIComponent(e) + "&via=" + o,
                    "shareit",
                    "toolbar=0,status=0,width=626,height=436"
                )
            }

            if (el.id === 'shareOnLinkedin') {
                return window.open(
                    "https://www.linkedin.com/sharing/share-offsite/?url=" + encodeURIComponent(str),
                    "linkedinsharedialog",
                    "toolbar=0,status=0,width=626,height=436"
                );
            }
        }
    });
}

export function createOffcanvasBackdrop(offCanvas: HTMLElement) {
    const backdrop = document.createElement('div');
    backdrop.className = '_mdco-offcanvas-backdrop fade show';
    backdrop.addEventListener('click', () => {
        closeOffCanvas(offCanvas);
    });
    const body = document.querySelector('body') as HTMLElement;
    body.appendChild(backdrop);
}

export function closeOffCanvas(offCanvas: HTMLElement) {
    offCanvas.classList.remove('show');
    offCanvas.setAttribute('aria-modal', 'false');
    const backdrop = document.querySelector('._mdco-offcanvas-backdrop') as HTMLElement;
    if (backdrop) {
        backdrop.classList.remove('show');
        setTimeout(() => {
            offCanvas.remove();
            backdrop.remove();
        }, 300);
    }
}

export async function copyTextFromSpan() {
    const spanElement = document.querySelector('._mdco-direct-link') as HTMLElement;

    const checkAnimation = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 130.2 130.2">
                                <circle class="path circle" fill="none" stroke="#73AF55" stroke-width="6" stroke-miterlimit="10" cx="65.1" cy="65.1" r="62.1"/>
                                <polyline class="path check" fill="none" stroke="#73AF55" stroke-width="6" stroke-linecap="round" stroke-miterlimit="10" points="100.2,40.2 51.5,88.8 29.8,67.5 "/>
                            </svg>`;

    if (spanElement) {
        const textToCopy = spanElement.innerText;

        try {
            await navigator.clipboard.writeText(textToCopy);
            const button = document.querySelector('._mdco-copy-link-button span');
            if (button) {
                button.innerHTML = checkAnimation;
            }
        } catch (err) {
            console.error('Metin kopyalanamadı: ', err);
        }
    } else {
        alert('Span elementi bulunamadı!');
    }
}






export function applyCssFile(brandSlug: string) {
    const cssId = `${brandSlug}-${new Date().getTime()}`;  // you could encode the css path itself to generate id..
    if (!document.getElementById(cssId)) {
        var head = document.getElementsByTagName('head')[0];
        var link = document.createElement('link');
        link.id = cssId;
        link.rel = 'stylesheet';
        link.type = 'text/css';
        link.href = `https://cdn.adpartners.io/adp-client/dist/${brandSlug}.css`;
        link.media = 'all';
        head.appendChild(link);
    }
}

//#endregion